import fa_lei from "./fa_lei.json";
import fa_bir from "./fa_bir.json";

const footers = {
  fa_lei,
  fa_bir,
};

export function getFooterPageData() {
  return footers[`${CONFIG.league}_${CONFIG.tricode}`];
}
